var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-container"},[_c('van-skeleton',{attrs:{"row":15,"loading":_vm.loading}},[_c('div',{staticStyle:{"margin-top":"20px"},domProps:{"innerHTML":_vm._s(_vm.activity)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }